import { Invoice } from 'api/invoices';

// Types

export type MainStoreInvoicesState = {
  byId: Record<string, Invoice & { isFetching: boolean }>;
};

export type FetchInvoiceRequestAction = {
  type: 'FETCH_INVOICE_REQUEST';
  invoiceId: string;
};

export type FetchInvoiceSuccessAction = {
  type: 'FETCH_INVOICE_SUCCESS';
  invoice: Invoice;
};

export type MainStoreInvoicesAction =
  | FetchInvoiceRequestAction
  | FetchInvoiceSuccessAction;

// Reducer

export function invoicesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreInvoicesState = {
    byId: {},
  },
  action: MainStoreInvoicesAction,
) {
  switch (action.type) {
    case 'FETCH_INVOICE_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoiceId]: {
            ...state.byId[action.invoiceId],
            id: action.invoiceId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_INVOICE_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoice.id]: { ...action.invoice, isFetching: false },
        },
      };

    default:
      return state;
  }
}
